module.exports = __webpack_public_path__ + "img/en_Ecran 3.026a56d8.png";